module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai107-9960fda258f6d12a6865bf3f7c918b2e.jpg";